import { render, staticRenderFns } from "./MarketNewsItemCreate.vue?vue&type=template&id=12ed8ff0"
import script from "./MarketNewsItemCreate.vue?vue&type=script&lang=js"
export * from "./MarketNewsItemCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports